import concat from 'lodash/concat';
import uniqBy from 'lodash/uniqBy';

export const SEARCH_PARTNERS_RESPONSE_RECEIVED = 'searchResults/PARTNERS_RESPONSE_RECEIVED';
export const SEARCH_BEST_MATCH_RESPONSE_RECEIVED = 'searchResults/BEST_MATCH_RESPONSE_RECEIVED';
export const SEARCH_NON_PARTNERS_RESPONSE_RECEIVED = 'searchResults/NON_PARTNERS_RESPONSE_RECEIVED';
export const SEARCH_IN_PROGRESS = 'searchResults/SEARCH_IN_PROGRESS';

export const SEARCH_NEARBY_CITIES_SEARCH_IN_PROGRESS =
  'searchResults/NEARBY_CITIES_SEARCH_IN_PROGRESS';
export const SEARCH_NEARBY_BRANDS_SEARCH_IN_PROGRESS =
  'searchResults/NEARBY_BRANDS_SEARCH_IN_PROGRESS';

export const SEARCH_NEARBY_CITIES_RESPONSE_RECEIVED =
  'searchResults/NEARBY_CITIES_RESPONSE_RECEIVED';
export const SEARCH_NEARBY_BRANDS_RESPONSE_RECEIVED =
  'searchResults/NEARBY_BRANDS_RESPONSE_RECEIVED';

export const CLEAR_SEARCH_RESULTS = 'searchResults/CLEAR_RESULTS_SET';

const initialState = {
  nearby: {
    cities: [],
    brands: [],
    isFetchingCities: false,
    isFetchingBrands: false,
  },
};

export function searchInProgress(type, value) {
  return {
    type: SEARCH_IN_PROGRESS,
    payload: { type, value },
  };
}

export function receivePartnersSearch(value) {
  return {
    type: SEARCH_PARTNERS_RESPONSE_RECEIVED,
    payload: { value },
  };
}

export function receiveBestMatch(value) {
  return {
    type: SEARCH_BEST_MATCH_RESPONSE_RECEIVED,
    payload: { value },
  };
}

export function setNearbyCitiesSearchInProgress(value) {
  return {
    type: SEARCH_NEARBY_CITIES_SEARCH_IN_PROGRESS,
    payload: { value },
  };
}

export function setNearbyBrandsSearchInProgress(value) {
  return {
    type: SEARCH_NEARBY_BRANDS_SEARCH_IN_PROGRESS,
    payload: { value },
  };
}

export function receiveNearbyCitiesResponseSearch(value) {
  return {
    type: SEARCH_NEARBY_CITIES_RESPONSE_RECEIVED,
    payload: { value },
  };
}

export function receiveNearbyBrandsResponseSearch(value) {
  return {
    type: SEARCH_NEARBY_BRANDS_RESPONSE_RECEIVED,
    payload: { value },
  };
}

export function receiveNonPartnersSearch(value) {
  return {
    type: SEARCH_NON_PARTNERS_RESPONSE_RECEIVED,
    payload: { value },
  };
}

export const clearSearchResults = () => ({
  type: CLEAR_SEARCH_RESULTS,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_IN_PROGRESS: {
      const { type, value } = action.payload;
      const key = `${type}SearchInProgress`;
      return {
        ...state,
        [key]: value,
      };
    }

    case SEARCH_PARTNERS_RESPONSE_RECEIVED: {
      const { response } = action.payload.value;
      const currentResultsSet = state.partnersResults || [];
      return {
        ...state,
        partnersResults: uniqBy(concat(currentResultsSet, response.results), 'id'),
        partnersPagination: response.pagination,
      };
    }

    case SEARCH_NON_PARTNERS_RESPONSE_RECEIVED: {
      const { response } = action.payload.value;
      const currentResultsSet = state.nonPartnersResults || [];
      return {
        ...state,
        nonPartnersResults: uniqBy(concat(currentResultsSet, response.results), 'id'),
        nonPartnersPagination: response.pagination,
      };
    }

    case CLEAR_SEARCH_RESULTS:
      return initialState;

    case SEARCH_BEST_MATCH_RESPONSE_RECEIVED: {
      const { response } = action.payload.value;
      return {
        ...state,
        bestMatchResults: response.results,
      };
    }

    case SEARCH_NEARBY_CITIES_SEARCH_IN_PROGRESS:
      return {
        ...state,
        nearby: { ...state.nearby, isFetchingCities: action.payload.value },
      };
    case SEARCH_NEARBY_BRANDS_SEARCH_IN_PROGRESS:
      return {
        ...state,
        nearby: { ...state.nearby, isFetchingBrands: action.payload.value },
      };
    case SEARCH_NEARBY_CITIES_RESPONSE_RECEIVED:
      return {
        ...state,
        nearby: { ...state.nearby, cities: action.payload.value.results },
      };
    case SEARCH_NEARBY_BRANDS_RESPONSE_RECEIVED:
      return {
        ...state,
        nearby: { ...state.nearby, brands: action.payload.value.results },
      };
    default:
      return state;
  }
};
